var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-child p-1 mx-1 mb-2",on:{"click":_vm.emitClick}},[_c('div',{staticClass:"img"},[_c('div',{staticClass:"img-container"},[_c('img',{attrs:{"src":_vm.img,"width":"140","height":"120"}})]),_c('div',{staticClass:"title mt-1",attrs:{"title":_vm.title}},[_vm._v(" "+_vm._s(_vm.title)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }